// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Input,
//   Button,
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Heading,
//   VStack,
//   Spinner,
//   Text,
//   useToast,
//   Stack,
// } from "@chakra-ui/react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import Nav from "../components/navbar";
// import moment from "moment";

// interface TimelineEntry {
//   date: string;
//   produced: number | null;
//   sold: number | null;
//   audited: number | null;
//   runningStock: number;
// }

// interface TimelineResponse {
//   description: string;
//   timeline: TimelineEntry[];
// }

// const ItemTimeline = () => {
//   const { description } = useParams();
//   const [timeline, setTimeline] = useState<TimelineEntry[] | null>(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const toast = useToast();

//   useEffect(() => {
//     if (description) {
//       fetchTimeline(decodeURIComponent(description));
//     }
//   }, [description]);

//   const fetchTimeline = async (desc: string) => {
//     setIsLoading(true);
//     setTimeline(null);

//     try {
//       const response = await axios.post<TimelineResponse>(`${process.env.REACT_APP_TEST_API_URL}/analytics/stock/timeline`, {
//         description: desc,
//       });
//       console.log(response.data);
//       setTimeline(response.data.timeline);
//     } catch (error) {
//       console.error("Failed to fetch timeline:", error);
//       toast({
//         title: "Error fetching timeline.",
//         status: "error",
//         isClosable: true,
//       });
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <Stack>
//       <Stack position="sticky" top={0} zIndex={1} width="full">
//         <Nav pageName={"Goods Analytics"} />
//       </Stack>

//       <Box maxW="6xl" mx="auto" py={8} px={4}>
//         <Heading size="lg" mb={6}>
//           Timeline for: {decodeURIComponent(description || "")}
//         </Heading>

//         {isLoading && (
//           <Box mt={6}>
//             <Spinner />
//           </Box>
//         )}

//         {timeline && (
//           <Box mt={10} overflowX="auto">
//             {timeline.length === 0 ? (
//               <Text>No data found.</Text>
//             ) : (
//               <Table variant="striped" colorScheme="gray">
//                 <Thead>
//                   <Tr>
//                     <Th>Date</Th>
//                     <Th>Produced (g)</Th>
//                     <Th>Sold (g)</Th>
//                     <Th>Audited (g)</Th>
//                     <Th>Running Stock</Th>
//                   </Tr>
//                 </Thead>
//                 <Tbody>
//                   {timeline.map((entry) => (
//                     <Tr key={entry.date}>
//                       <Td>{moment(entry.date).format("DD MMM YYYY")}</Td>
//                       <Td>{(entry.produced && (entry.produced)/1000) ?? "-"}</Td>
//                       <Td>{(entry.sold && (entry.sold)/1000) ?? "-"}</Td>
//                       <Td>{(entry.audited && (entry.audited)/1000) ?? "-"}</Td>
//                       <Td fontWeight="bold">{(entry.runningStock && (entry.runningStock)/1000)}</Td>
//                     </Tr>
//                   ))}
//                 </Tbody>
//               </Table>
//             )}
//           </Box>
//         )}
//       </Box>
//     </Stack>
    
//   );
// };

// export default ItemTimeline;


import {
  Box,
  VStack,
  HStack,
  Text,
  Badge,
  Icon,
  Heading,
  Divider,
  useColorModeValue,
  Modal,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  Stack,
  ModalFooter,
  ButtonGroup,
  Button,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Spinner,
  useBreakpointValue,
  Center,
  color,
  Tfoot,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaBoxOpen, FaShoppingCart, FaBalanceScale, FaChartLine } from "react-icons/fa";
import axios from "axios";
import OrderDetailsScreen from "./OrderDetails";
import Nav from "../components/navbar";
import moment from "moment";
import { Loading } from "../components/Loading";

interface SaleDetail {
  quantity: number;
  transactionNumber: number;
  userId: string;
}

interface TimelineEntry {
  date: string;
  produced: number;
  sold: number;
  audited: number | null;
  runningStock: number;
  sales: SaleDetail[];
}

const ItemTimeline = () => {
  const { description } = useParams();
  const [timeline, setTimeline] = useState<TimelineEntry[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<number>(0);
  const [showPreviewModal, setShowPreviewModal] = useState<boolean>(false);
  const [userId, setUserId] = useState<string>('');
  const [table, setTable] = useState<boolean>(true);

  const isSmallScreen = useBreakpointValue({ base: true, md: true, lg: false });

  useEffect(() => {
    if (description) {
      fetchTimeline(description);
    }
  }, [description]);

  const fetchTimeline = async (desc: string) => {
    try {
      setLoading(true);
      const res = await axios.post(`${process.env.REACT_APP_TEST_API_URL}/analytics/stock/timeline`, { description: decodeURIComponent(desc) });
      console.log(res);
      setTimeline(res.data.timeline || []);
    } catch (err) {
      console.error("Failed to fetch timeline:", err);
    } finally {
      setLoading(false);
    }
  };

  const cardBg = useColorModeValue("white", "gray.800");

  return (
    <Stack pb={5}>
      <Stack position="sticky" top={0} zIndex={1} width="full">
        <Nav pageName={"Goods Analytics"} />
      </Stack>
      <Box px={5}>
        <HStack justifyContent={"space-between"}>
          <Heading size="lg" mb={6}>
            Timeline for: {decodeURIComponent(description || "")}
          </Heading>

          <Button onClick={()=> setTable(!table)}>{table ? "Cards" : "Table"}</Button>
        </HStack>
        

        {loading && (
          <Center h={600}>
            <Loading />
          </Center>
        )}


        {!loading && !table && <VStack spacing={6} align="stretch">
          {timeline.map((entry, index) => (
            <Box
              key={index}
              bg={cardBg}
              boxShadow="md"
              borderRadius="2xl"
              p={6}
              borderLeft="4px solid"
              borderColor="blue.400"
            >
              <HStack justify="space-between" mb={3}>
                <Text fontWeight="bold" fontSize="lg">
                  {moment(entry.date).format("DD MMM YYYY")}
                </Text>
                <Badge colorScheme="purple" variant="subtle">
                  Day #{index + 1}
                </Badge>
              </HStack>

              <VStack align="start" spacing={2}>
                <HStack>
                  <Icon as={FaBoxOpen} color="green.500" />
                  <Text>
                    Produced: <strong>{entry.produced/1000}</strong> Kg
                  </Text>
                </HStack>

                <HStack align="start">
                  <Icon as={FaShoppingCart} color="red.500" mt={0.5} />
                  <Box>
                    <Text>Sold: <strong>{entry.sold/1000}</strong> Kg</Text>
                    {entry.sales?.map((s, i) => (
                      <Text onClick={()=>{setSelectedTransaction(s.transactionNumber);
                        setUserId(s.userId);
                        setShowPreviewModal(true);
                      }} key={i} fontSize="sm" ml={4}>
                        - {s.quantity/1000} Kg on Invoice #{s.transactionNumber}
                      </Text>
                    ))}
                  </Box>
                </HStack>

                {entry.audited !== null && (
                  <HStack>
                    <Icon as={FaBalanceScale} color="orange.400" />
                    <Text>
                      Physical Audit: <strong>{entry.audited/1000}</strong> Kg
                    </Text>
                  </HStack>
                )}

                <Divider my={2} />

                <HStack>
                  <Icon as={FaChartLine} color="blue.500" />
                  <Text fontWeight="semibold">
                    Running Stock: {entry.runningStock/1000} Kg
                  </Text>
                </HStack>
              </VStack>
            </Box>
          ))}
        </VStack>}

        {!loading && table && timeline && (
          <Box mt={10} overflowX="auto">
            {timeline.length === 0 ? (
              <Text>No data found.</Text>
            ) : (
              <Table variant="striped" colorScheme="gray">
                <Thead>
                  <Tr>
                    <Th>Date</Th>
                    <Th isNumeric>Produced (Kg)</Th>
                    <Th isNumeric>Sold (Kg)</Th>
                    <Th isNumeric>Transactions</Th>
                    <Th isNumeric>Audited (Kg)</Th>
                    <Th isNumeric>Running Stock</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {timeline.map((entry) => (
                    <Tr key={entry.date}>
                      <Td>{moment(entry.date).format("DD MMM YYYY")}</Td>
                      <Td isNumeric>{(entry.produced && (entry.produced)/1000) ?? "-"}</Td>
                      <Td isNumeric>{(entry.sold && (entry.sold)/1000) ?? "-"}</Td>
                      <Td isNumeric>
                          {entry.sales?.map((s, i) => (
                            <Text
                            color= {s.userId === "admin@koas.com" ? "red.500" : "null"}
                            onClick={()=>{setSelectedTransaction(s.transactionNumber);
                              setUserId(s.userId);
                              setShowPreviewModal(true);
                              
                            }} key={i} fontSize="sm" ml={4}>
                              {s.quantity/1000} Kg on Invoice #{s.transactionNumber} 
                            </Text>
                          ))}
                      </Td>
                      <Td isNumeric>{(entry.audited && (entry.audited)/1000) ?? "-"}</Td>
                      <Td isNumeric fontWeight="bold">{(entry.runningStock && (entry.runningStock)/1000)}</Td>
                    </Tr>
                  ))}
                </Tbody>
                <Tfoot>
                  <Tr>
                    <Th>Date</Th>
                    <Th isNumeric>Produced (Kg)</Th>
                    <Th isNumeric>Sold (Kg)</Th>
                    <Th isNumeric>Transactions</Th>
                    <Th isNumeric>Audited (Kg)</Th>
                    <Th isNumeric>Running Stock</Th>
                  </Tr>
                </Tfoot>
              </Table>              
            )}
          </Box>)}

        <Modal
          size="xl"
          isCentered
          closeOnOverlayClick={false}
          isOpen={showPreviewModal}
          onClose={() => setShowPreviewModal(false)}
        >
          <ModalContent>
            <ModalCloseButton />
            <ModalHeader>Preview</ModalHeader>
            <ModalBody>
              <Stack>
              <OrderDetailsScreen ID={selectedTransaction.toString()} otheremail={userId} product={description} />
              </Stack>
            </ModalBody>
            <ModalFooter>
              <ButtonGroup>
                <Button
                  colorScheme="red"
                  onClick={() => {
                    setShowPreviewModal(false);
                  }}
                >
                  Close
                </Button>
              </ButtonGroup>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Box>
    </Stack>
  );
};

export default ItemTimeline;

